import { useSsoLogin } from '../../../../api/auth/src';
import { useNotifications } from '../../../shared-ui';
import { useI18n } from '../../../i18n/src';
import { ssoLoginRedirectSuccess } from '../components/helpers/ssoLoginRedirectSuccess';
import { ssoLoginRedirectFailure } from '../components/helpers/ssoLoginRedirectFailure';

export const useSsoLoginWithHandlers = () => {
  const { notifyError } = useNotifications();
  const { getIntlString } = useI18n();

  return useSsoLogin({
    onSuccess: ssoLoginRedirectSuccess,
    onError: () => ssoLoginRedirectFailure(notifyError, getIntlString),
  });
};
